/* eslint-disable no-undef */

import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['description']
  static values = {
    entries: Object
  }

  updateDescription({ target: { value } }) {
    const newDescription = this.entriesValue[value]
    this.descriptionTarget.textContent = newDescription
  }
}
